import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { TinymceComponent } from '../../editors/tinymce/tinymce.component';

import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { ApiService } from '../../../services';
import { UscAttachmentLookupComponent } from '../usc-attachment-lookup/usc-attachment-lookup.component';

@Component({
  selector: 'sn-usc-email-composer',
  templateUrl: './usc-email-composer.component.html',
  styleUrls: ['./usc-email-composer.component.css', '../usc-store.component.css'],
  // host: {
  //   '[style.display]': '"flex"',
  //   '[style.flex-direction]': '"column"',
  //   '[style.overflow]': '"hidden"'    
  // }
})
export class UscEmailComposerComponent implements OnInit {
  @Input() view:string;
  @Input() item:any;
  @Input() curr_event:any;

  public modal_status:string = "modal_loading";

  public recipients:string = "";
  public sender:string = "";
  public subject:string = "";
  public content:string = "";
  public currentTemplate:any;
  public emailTemplates:Array<any>;
  public selectedTemplateID:any;
  public settings:any;
  public is_send_email: boolean;

  constructor(
    public uscStoreService: UscStoreService,
    public ngbModal: NgbModal,
    public activeModal: NgbActiveModal,
    public apiService: ApiService
    
  ) { }

  ngOnInit() {
    this.is_send_email = false;
    this.emailTemplates = this.uscStoreService.getEmailTemplatesByView(this.view, this.curr_event);
    this.currentTemplate = this.emailTemplates[0];
    this.selectedTemplateID = this.currentTemplate.ID;
    this.settings = {
      height: 300,
      menubar: '',
      toolbar: ' ',
      readonly: true
    }
    if (this.uscStoreService.isUSCellTelesales()) {
      this.settings = { 
        height: 300,
        menubar: '',
        toolbar1: "undo redo | alignleft aligncenter alignright alignjustify | outdent indent | fontselect fontsizeselect | bold italic underline | styleselect ",
      }
    }

    this.applyEmailTemplate();
  }

  onChange(event) {
    //console.log(event);
    this.applyEmailTemplate();
  }

  applyEmailTemplate() {
    var view_ID = 11106657;
    if (this.item && this.item.view_ID) view_ID = this.item.view_ID;
    this.uscStoreService.translateEmailTemplate(this.selectedTemplateID, "deal", view_ID).subscribe(
      template => {
        this.recipients = template.email_to;
        this.sender = template.email_from;
        this.subject = template.email_subject;
        this.content = template.email_body;
        this.modal_status = "modal_loaded";
      }
    )
  }

  sendEmail() {
    this.is_send_email = true;
    this.currentTemplate.email_from = this.sender;
    this.currentTemplate.email_to = this.recipients;
    this.currentTemplate.email_subject = this.subject;
    this.currentTemplate.email_body = this.content;
    this.currentTemplate.is_body_html = "Y";

    var params = { save_as_em: true, related_ID: this.item.view_ID, related_type: 'DL' }
    this.uscStoreService.sendEmailTemplate(this.currentTemplate, this.emailAttachments, params).subscribe(
      result => { 
            this.is_send_email = false;
            this.activeModal.close(true); 
        }
    );
  }

  cancel() {
    this.activeModal.dismiss();
  }

  isFileUploading:boolean = false;
  emailAttachments:any[] = [];
  uploadFile(event) {
    this.isFileUploading = true;
    let file = event.target.files[0];
    let formData = new FormData();
    formData.append("filename", file.name);
    formData.append("file", file);
    event.target.value = null;
    this.apiService.postFile("/models/file/upload", formData).subscribe(
      result => {
        this.isFileUploading = false;
        this.emailAttachments.push(result);
      }
    );
  }

  removeAttachment(attachment, index) {
     this.emailAttachments.splice(index, 1);
  }

  showAttachments(item) {
    const modalRef = this.ngbModal.open(UscAttachmentLookupComponent, { size: "lg", backdrop: 'static', keyboard: false });
    modalRef.componentInstance.view = this.view;
    modalRef.componentInstance.related_type = "contact";
    modalRef.componentInstance.related_ID = item.co_ID;
    modalRef.componentInstance.data = item;
    modalRef.componentInstance.mode = "picker";    
    modalRef.result.then((result) => {
      console.log(result);
      if (result && result.selectedItem) this.emailAttachments.push(result.selectedItem);
      }, (reason) => {
      console.log('Attachment Closed');
    });
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-email-composer/usc-email-composer.component.ts